module.exports = __webpack_public_path__ + "static/img/contract_active.7ad38ccc.png";